import type { ErrorEvent, EventHint } from '@sentry/vue';
import { isAxiosError } from 'axios';

import {
  isPendingLivenessCheckResponse,
  isPendingLivenessCheckSentinelError,
} from '@peanuds/shared';

const isExpectedLivenessAxiosError = (error: unknown) => {
  if (!isAxiosError(error)) {
    return false;
  }

  return error.response?.status === 409 && isPendingLivenessCheckResponse(error.response);
};

const isExpectedLivenessSentryException = (error: unknown) => {
  if (isPendingLivenessCheckSentinelError(error)) {
    return true;
  }

  return isExpectedLivenessAxiosError(error);
};

export const ignoreExpectedLivenessSentryEvents = (event: ErrorEvent, hint: EventHint) => {
  if (isExpectedLivenessSentryException(hint.originalException)) {
    return null;
  }

  return event;
};
